<template>
	<div class="form-inputs">
		<FormLabelTooltip
			v-if="label"
			:required="required"
			:name="`input-${name}`"
			:label="label"
			:tooltip="tooltip"
		/>
		<input
			v-if="mask == null || typeof mask === 'undefined'"
			class="b360-form-input"
			:class="{ error: error }"
			:id="`input-${name}`"
			:type="type"
			:placeholder="placeholder"
			:pattern="pattern"
			:required="required"
			:value="value"
			:disabled="disabled"
			:maxlength="maxLength"
			:min="min"
			:max="max"
			:step="step"
			@change="$emit('handle-change')"
			@blur="handleBlur"
			v-model="inputVal"
			@input="handleInput"
			ref="inputField"
		/>

		<MaskedInput
			v-else
			class="b360-form-input"
			:class="{ error: error }"
			:id="`input-${name}`"
			:type="type"
			:placeholder="placeholder"
			:pattern="pattern"
			:required="required"
			:value="value"
			:mask="mask"
			:disabled="disabled"
			:guide="false"
			:maxlength="maxLength"
			:min="min"
			:max="max"
			:step="step"
			v-model="inputVal"
			@input="handleMaskInput"
			@keydown.delete="overrideDelete"
			ref="inputField"
		>
		</MaskedInput>
	</div>
</template>

<script>
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';
import MaskedInput from 'vue-text-mask';

export default {
	name: 'FormInputs',
	components: {
		FormLabelTooltip,
		MaskedInput,
	},
	props: {
		name: '',
		label: '',
		type: '',
		placeholder: '',
		pattern: '',
		patternDescription: '',
		required: '',
		formField: '',
		value: '',
		tooltip: '',
		disabled: '',
		mask: '',
		guide: '',
		value: '',
		maxLength: '',
		min: '',
		max: '',
		step: '',
		error: '',
		shouldFocus: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			inputVal: this.value,
		};
	},
	methods: {
		handleBlur() {
			this.$emit('blur');
		},
		handleInput(event) {
			this.$emit('handle-input', {
				value: event.target.value,
				fieldName: this.name,
			});
		},

		handleChange(event) {
			this.$emit('handle-change', {
				value: event.target.value,
				fieldName: this.name,
			});
		},

		handleMaskInput(event) {
			this.$emit('handle-input', {
				value: event,
				fieldName: this.name,
			});
		},
		overrideDelete(event) {
			const value = event.target.value;
			const char = value[value.length - 1];
			if (isNaN(parseInt(char)) || char == ' ') {
				event.target.value = value.substring(0, value.length - 1);
			}
		},
	},
	watch: {
		inputVal(val) {
			this.$emit('input', val);
		},
		value(val) {
			this.inputVal = val;
		},
	},
	mounted() {
		if (this.shouldFocus) {
			this.$refs.inputField.focus();
		}
	},
};
</script>

<style scoped lang="scss">
.b360-form-label {
	display: flex;
	justify-content: space-between;
}
.error {
	border: 1px solid $error;
}
</style>
